<template>
  <div class="input">
    <div class="page-box">
      <h2 v-html="getTitle" />
      <div v-if="privacyContent" v-html="privacyContent" />
    </div>

    <div class="input-wrapper">
      <input
        id="input-checkbox-privacy"
        v-on:change="onChange($event)"
        type="checkbox"
        name="input-checkbox-privacy"
        class="u-visually-hidden"
      >
      <label v-html="getLinkLabel" for="input-checkbox-privacy" class="label-privacy" />
    </div>
  </div>
</template>

<script>
import pages from '@/data/static-pages';

export default {
  props: {
    question: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      privacyVisibility: false,
      privacyContent: null,
      privacyLink: ""
    }
  },
  computed: {
    getTitle() {
      if (!this.privacyLink) return this.$t('privacy.title-symplicy');
      return this.$t('privacy.title');
    },
    getLinkLabel() {
      if (!this.privacyLink) return this.$t('form.labels.privacy-symplicy');
      return this.$t('form.labels.privacy', { link: this.privacyLink });
    }
  },
  async beforeMount() {
    let privacy = await this.$store.dispatch('calls/getPolicy', 'privacy');
    const policy = privacy.status === 'success' && privacy.data?.data?.length ? privacy.data.data.filter(p => p.lang === this.$i18n.locale) : null;

    if (policy?.[0] && policy[0].content) {
      this.privacyLink = privacy.data?.pdf ? privacy.data.pdf[this.$i18n.locale] : null;
      privacy = policy[0].content;
      this.$emit("type", "lawyer");
    } else {
      privacy = await this.$store.dispatch('calls/staticPage', pages[this.$store.state.locale].privacy);
      privacy = privacy.data.acf?.[this.$store.state.locale];
      this.$emit("type", "symplicy");
    }

    this.privacyContent = privacy;
  },
  methods: {
     onChange(e) {
      const $input = e.currentTarget;
      const index = this.$store.state.form.content.data.indexOf(this.question);
      const value = $input.checked;
      this.$store.commit('form/updateValue', { index, value });
    }
  }
}
</script>

<style lang="scss" scoped>
  .input {
    // Page box
    .page-box {
      @include margin(15px null 20px);
      @include padding(20px);
      display: block;
      max-height: 100px;
      overflow: auto;
      background-color: color('input-background');
      color: color('input-text');
      font-family: var(--symplicy-font-secondary);
      font-size: rem(14px);
      line-height: 1.4;

      h2,
      h3,
      h4 {
        margin-bottom: 10px;
        font-weight: 600;

        &:not(:first-child) {
          margin-top: 20px;
        }
      }

      p,
      ul {
        + p,
        + ul {
          @include margin(10px null null null);
        }
      }
    }

    // Input
    &-wrapper {
      @include margin(8px null null);
    }

    input:checked {
      + label {
        &::after {
          opacity: 1;
          transform: scale(1);
        }
      }
    }

    label {
      @include padding(null null null 32px);
      display: block;
      position: relative;
      transition: color .3s $ease-out-quart;
      color: color('text');
      font-family: var(--symplicy-font-secondary);
      font-size: rem(14px);
      line-height: (24 / 14);
      cursor: pointer;

      @include mq($until: 'm') {
        line-height: (20 / 14);
      }

      &:focus,
      &:hover {
        color: color('highlight');

        &::before {
          background-color: color('highlight', .2);
        }
      }

      &::before {
        @include position(absolute, 4px null null 0);
        @include size(16px);
        content: '';
        transition: background-color .3s $ease-out-quart;
        border: 1px solid color('highlight');

        @include mq($until: 'm') {
          top: 2px;
        }
      }

      &::after {
        @include position(absolute, 6px null null 2px);
        @include size(12px);
        content: '';
        transform: scale(.6);
        transition: opacity .3s $ease-out-quad, transform .3s $ease-out-quad;
        opacity: 0;
        background-color: color('highlight');

        @include mq($until: 'm') {
          top: 4px;
        }
      }
    }
  }
</style>

<style lang="scss">
  .page-box-toggle {
    strong {
      font-weight: normal;
    }
  }
</style>
